import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withLaunchDarkly } from 'utils/sdks/launchDarkly.v2'
import { withMixpanel } from 'utils/sdks/mixpanel'

import { sortOrders } from 'store/orderList/actions'
import { getSelectedQuickFilters } from 'store/quickFilters/selectors'

import { withAnalytics } from './OrderTable.analytics'
import OrderTable from './OrderTable.component'

const mapStateToProps = (state) => ({
  orderBy: state.orderList.orderBy,
  selectedFilters: getSelectedQuickFilters(state),
})

const mapDispatchToProps = {
  sortOrders,
}

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withMixpanel,
  withRouterCustom,
  withAnalytics,
  withLaunchDarkly,
)(OrderTable)
